// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const SleepFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M46.76 87.5c-16.757 0-31.996-10.532-37.92-26.21a2 2 0 0 1 2.515-2.6 36.464 36.464 0 0 0 11.792 1.957c20.144 0 36.532-16.388 36.532-36.532 0-4.432-.792-8.775-2.354-12.908a2 2 0 0 1 2.516-2.6 40.523 40.523 0 0 1 27.45 38.36c0 22.35-18.183 40.533-40.532 40.533"
			fillRule="evenodd"
		/>
	</svg>
);
export default SleepFilled;
